<template>

<div v-if='message' class="row">
    <div class="col-12 mb-2">
        <div :class="['alert', 'alert-danger']" role="alert">
            <span :class="['icon','icon-alert-octagon']"></span>
            {{ message }}
        </div>
    </div>
</div>

</template>

<script>
    export default {
        mounted() {
            this.validateChange();
        },

        created() {
            for( var i in this.fields ) {
                this.flds.push( Object.assign({}, this.field, this.fields[i]) );
            }
        },

        beforeDestroy() {
            this.unValidateChange();
        },

        props : ['fields'],

        data(){
            return {
                message : false,

                field : {
                    selector  : false,  //Jquery selector
                    sameAs    : false,  //Jquery selector for validating password repeat etc.
                    minLength : false,  //Compare string length
                    maxLength : false,  //Compare string length
                    min       : false,  //Compare integer value
                    max       : false,  //Compare integer value
                    required  : true,  //If not required, null is accepted, even if the above are not matched
                    regex     : false,   //Compare value to a regex string. 
                    customErr : false,   //Custom error message on bad input
                    customFunc: false,   //Custom function, executed on error
                    dataCheck : false,   //Should the data-value attribute of the input be checked instead. Works for file inputs
                    errMsgHolder    : false, // if ! false, the error message will be prepended to this Jquery Selector
                    canBeNull       : false,    //If value is not set, do not validate ( pwd & pwd repeat on update)
                    validateChange  : true,    //If value is true, the field will be validated on change.
                },

                flds : [],

                options : {
                    notify   : false,
                    inputMsg : true,
                }
            }
        },

        methods : {
            //Accept 2 callbacks for either case
            validate( params ) {
                if( typeof params == 'undefined' ) {
                    params = {};
                }

                var firstEl = false;
                var problems = 0;

                this.removeErrors();

                for( var i in this.flds ) {
                    
                    var res = this.checkField( this.flds[i] );

                    if( !res ) {
                        continue;
                    }

                    if( res.localPass ) {

                        this.markValid( res.el );

                    } else {

                        if( !firstEl || firstEl.top > res.el.offset().top ) {
                            firstEl = res.el;
                        }

                        this.generateError( res.el, res.errors, this.flds[i] );
                        this.markInvalid( res.el );
                        
                        if( typeof this.flds[i].customFunc == 'function' ) {
                            this.flds[i].customFunc();
                        };

                        problems++;
                    }

                }

                if( problems > 0 ) {
                    this.message = 'Моля попълнете всички задължителни полета коректно.';

                    if( firstEl ){
                        $(window).scrollTop( firstEl.offset().top + 100 );
                        firstEl.focus();
                    }

                    if( typeof params.reject == 'function' ) {
                        params.reject();
                    }

                } else {

                    this.message = false;
                    this.allValid();
                    
                    if( typeof params.resolve == 'function' ) {
                        params.resolve();
                    }

                }

            },

            validateChange() {
                for( var i in this.flds ) {
                    
                    if( this.flds[i].validateChange && this.flds[i].selector ) {
                        this.validateField( this.flds[i] );
                    }

                }
            },

            unValidateChange() {
                for( var i in this.flds ) {
                    
                    if( this.flds[i].validateChange && this.flds[i].selector  ) {
                        $("body").unbind('change', this.flds[i].selector);
                    }

                }
            },

            validateField( f ) {
                var el = $( f.selector ),
                    me = this;

                $("body").on('change', f.selector, function(){
                    var res = me.checkField( f );

                    if( res.localPass ){
                        
                        me.markValid( res.el );
                        $( ".input-error[data-for='"+ f.selector +"']" ).remove();

                    } else {

                        me.generateError( res.el, res.errors, f );
                        me.markInvalid( res.el );
                    }
                });
            },

            checkField( f ) {
                let el = $( f.selector );

                if( !el.length ){
                    console.log( "Element with selector '" + f.selector + "' was not found. Could not validate." );
                    return false;
                }

                var val     = el.val(),
                    errors  = {},
                    localPass = true;

                if( !val && f.dataCheck ) {
                    val = el.data('value');
                }

                if( f.required == false && !val ) {
                    //Not required, not presented
                    return false;
                }

                if( f.sameAs !== false ) {
                    var val2 =  $(f.sameAs).val();

                    if( f.canBeNull == true && !val && !val2 ) {

                    } else {

                        if( val !== val2 ) {
                            //sameAs  error
                            localPass     = false;
                            errors.sameAs = 1;
                        }
                    
                    }

                }

                if( f.min !== false && f.min > Number(val) ) {
                    //Min  error
                    localPass = false;
                    errors.min = 1;
                }

                if( f.max !== false && f.max < Number(val) ) {
                    //Max  error
                    localPass = false;
                    errors.max = 1;
                }

                if( f.minLength !== false && f.minLength > val.length ) {

                    if( f.canBeNull && !val.length ) {
                        //Skip
                    } else {
                        //Min length error
                        localPass = false;
                        errors.minLength = 1;
                    }

                }

                if( f.maxLength !== false && f.maxLength < val.length ) {
                    //Max length error
                    localPass = false;
                    errors.maxLength = 1;
                }

                if( f.regex !== false && val.match( f.regex ) == null ) {
                    //Regex length error
                    localPass = false;
                    errors.regex = 1;
                }

                if( f.required && !val && localPass ) {
                    localPass = false;
                    errors.required = 1;
                }


                return {
                    el          : el,
                    errors      : errors,
                    localPass   : localPass
                }
            },

            //How to mark invalid fields
            markInvalid( el, holder ) {
                el.closest('div.input').addClass('warning-input');
                el.closest('div.input').removeClass('success-input');
            },

            //How to mark invalid fields
            markValid( el ) {
                el.closest('div.input').removeClass('warning-input');
                el.closest('div.input').addClass('success-input');
            },

            //Validation passed
            allValid() {
                $('div.input').removeClass('warning-input');
            },

            //Generate information text error for the input
            generateError( el, errors, fld ) {
                if( typeof fld.customErr == 'string' ) {
                  
                    var str = fld.customErr;
                
                } else {

                    var str = '',
                        errCount = 0;

                    if( typeof errors.min != 'undefined' ) {
                       
                        str += ('Моля въведете число по-голямо от ' + fld.min );
                        errCount++;
                   
                    }else if ( typeof errors.max != 'undefined' ) {
                       
                        str += ('Моля въведете число по-mалко от ' + fld.max );
                        errCount++;

                    }

                    if( typeof errors.minLength != 'undefined' ) {
                    
                        if( errCount ){
                            str += ', с ';
                        } else {
                            str += 'Полето трябва да съдържа '
                        }

                        str += ('минимален брой символи : ' + fld.minLength );
                        errCount++;
                    
                    }else if ( typeof errors.maxLength != 'undefined' ) {
                                   
                        if( errCount ){
                            str += ', с ';
                        } else {
                            str += 'Полето трябва да съдържа '
                        }
                        
                        str += ('максимален брой символи : ' + fld.maxLength );
                        errCount++;

                    }


                    if( typeof errors.regex != 'undefined' ){
                        if( errCount ){
                            str += ', и съдържанието му да бъде валидно. ';
                        } else {
                            str += 'Съдържанието на полето не е валидно ';
                        }

                        errCount++;
                    }

                    if( typeof errors.sameAs != 'undefined' ){
                        if( errCount ){
                            str += ', и да съвпада с повторението. ';
                        } else {
                            str += 'Съдържанието на полето не съвпада с повторението';
                        }

                        errCount++;
                    }


                    if( errors.required && !errCount ) {
                        str += 'Това поле е задължително';
                        errCount++;
                    }

                }

                if( $(".input-error[data-for='"+ fld.selector +"']").length ){
                    $(".input-error[data-for='"+ fld.selector +"']").remove();
                }

                let err = $("<div data-for='" + fld.selector + "' class='input-error'>"+ str +"</div>");

                if( typeof fld.errMsgHolder == 'undefined' || !fld.errMsgHolder ){
                    el.after( err );
                } else { 
                    err.appendTo( $(fld.errMsgHolder) );
                }
            },

            removeErrors( el ) {
                $( ".input-error" ).remove();
            }

        },

        computed : {

        },

        watch : {
            
        }
    }
</script>
<style>

.control-wrap {
    position: relative !important;
    display: block;
}

.warning-input input {
    position: relative;
    border-color: #fb6662;
}

.warning-input input:focus{
    border-color: rgba(251, 102, 98, 0.5);
    box-shadow: 0px 0px 2px 2px rgba(251, 102, 98, 0.27);
    outline: 0 none;
}

.warning-input:after {
    color: #fb6662;
}

.input-error {
    background: #fb6662;
    border-radius: 0 0 10px 10px;
    border-top: none;
    color: #fff;
    display: inline-block;
    font-size: .8em;
    margin-left: 4%;
    max-width: 96%;
    padding: 4px 10px 2px;
}


</style>